(function () {
  if (document.documentElement.dataset.zenMainCollectionScriptLoaded === 'true') return;

  document.documentElement.dataset.zenMainCollectionScriptLoaded = 'true';

  var collectionSelector = '[data-zen-main-collection]';
  var formSelector = collectionSelector + ' .zen-ajax-cart-form';
  var filterHiddenClass = 'is-filter-hidden';
  var listViewClass = 'is-list-view';
  var viewStorageKey = 'zenCollectionView';
  var filterStorageKey = 'zenCollectionFiltersHidden';

  function getForms(container) {
    var root = container || document;
    var forms = [];

    if (root.matches && root.matches(formSelector)) forms.push(root);

    return forms.concat(Array.prototype.slice.call(root.querySelectorAll(formSelector)));
  }

  function destroyForm(form) {
    if (typeof form.zenMainCollectionCleanup === 'function') {
      form.zenMainCollectionCleanup();
    }
  }

  function initializeForm(form) {
    if (form.dataset.zenMainCollectionInitialized === 'true') return;

    var collection = form.closest(collectionSelector);
    var button = form.querySelector('button[type="submit"]');

    if (!collection || !button) return;

    var labels = {
      adding: collection.dataset.zenMainCollectionAddingLabel,
      added: collection.dataset.zenMainCollectionAddedLabel,
      error: collection.dataset.zenMainCollectionErrorLabel,
    };

    async function handleSubmit(event) {
      event.preventDefault();

      if (button.classList.contains('is-loading')) return;

      var originalText = button.innerHTML;
      button.classList.add('is-loading');
      button.innerHTML = labels.adding;

      try {
        var formData = new FormData(form);

        var response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) throw new Error('Cart error');

        button.innerHTML = labels.added;

        fetch('/cart.js')
          .then(function (cartResponse) {
            return cartResponse.json();
          })
          .then(function (cart) {
            var cartIcon =
              document.querySelector('#cart-icon-bubble') ||
              document.querySelector('.header__icon--cart');

            if (!cartIcon) return;

            var bubble = cartIcon.querySelector('.cart-count-bubble');

            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
              cartIcon.appendChild(bubble);
            } else {
              var span = bubble.querySelector('span');
              if (span) {
                span.textContent = cart.item_count;
              }
            }
          });

        window.setTimeout(function () {
          button.innerHTML = originalText;
          button.classList.remove('is-loading');
        }, 1500);
      } catch (error) {
        button.innerHTML = labels.error;

        window.setTimeout(function () {
          button.innerHTML = originalText;
          button.classList.remove('is-loading');
        }, 1500);
      }
    }

    form.addEventListener('submit', handleSubmit);
    form.dataset.zenMainCollectionInitialized = 'true';
    form.zenMainCollectionCleanup = function () {
      form.removeEventListener('submit', handleSubmit);
      delete form.dataset.zenMainCollectionInitialized;
      delete form.zenMainCollectionCleanup;
    };
  }

  function initializeForms(container) {
    getForms(container).forEach(initializeForm);
  }

  function destroyForms(container) {
    getForms(container).forEach(destroyForm);
  }

  function safeReadStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeWriteStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function initializeControls(container) {
    var root = container || document;
    var collections = [];

    if (root.matches && root.matches(collectionSelector)) collections.push(root);

    collections = collections.concat(Array.prototype.slice.call(root.querySelectorAll(collectionSelector)));

    collections.forEach(function (collection) {
      if (collection.dataset.zenCollectionControlsInitialized === 'true') return;

      var filterToggle = collection.querySelector('[data-zen-filter-toggle]');
      var filterToggleLabel = collection.querySelector('[data-zen-filter-toggle-label]');
      var filterPanel = collection.querySelector('[data-zen-filter-panel]');
      var viewButtons = Array.prototype.slice.call(collection.querySelectorAll('[data-zen-view-button]'));

      function setFilterHidden(isHidden) {
        collection.classList.toggle(filterHiddenClass, isHidden);

        if (filterToggle) {
          filterToggle.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
        }

        if (filterToggleLabel) {
          filterToggleLabel.textContent = isHidden ? 'Szűrők mutatása' : 'Szűrők elrejtése';
        }

        if (filterPanel) {
          filterPanel.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
        }

        safeWriteStorage(filterStorageKey, isHidden ? 'true' : 'false');
      }

      function setView(view) {
        var normalizedView = view === 'list' ? 'list' : 'grid';

        collection.classList.toggle(listViewClass, normalizedView === 'list');

        viewButtons.forEach(function (button) {
          var isActive = button.dataset.zenViewButton === normalizedView;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        safeWriteStorage(viewStorageKey, normalizedView);
      }

      if (filterToggle) {
        filterToggle.addEventListener('click', function () {
          setFilterHidden(!collection.classList.contains(filterHiddenClass));
        });
      }

      viewButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setView(button.dataset.zenViewButton);
        });
      });

      setFilterHidden(safeReadStorage(filterStorageKey) === 'true');
      setView(safeReadStorage(viewStorageKey));

      collection.dataset.zenCollectionControlsInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeForms(document);
      initializeControls(document);
    });
  } else {
    initializeForms(document);
    initializeControls(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeForms(event.target);
    initializeControls(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyForms(event.target);
  });
})();
